export default __webpack_public_path__ + "static/media/football.45e6797e.svg";